export default "__VITE_ASSET__BaQyAEdg__"